import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100vw;
	position: relative;
	background-color: ${({ theme }) => theme.gray[0]};
`;

export const TopBarWrapper = styled.div`
	position: relative;
	z-index: 100;
	flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
	flex: 1;
	display: flex;
	min-height: 0;
	position: relative;
`;

export const LeftPanel = styled.div`
	height: 100%;
	overflow: hidden;
`;

export const MainContent = styled.div`
	flex: 1;
	min-width: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

export const SectionContentWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

export const RightPanel = styled.div`
	flex-shrink: 0;
	width: 0;
	/* Reserved for future detail panel */
`;
